export const GET_USERS_SEND = "GET_USERS_SEND";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const USER_FORM_SEND = "USER_FORM_SEND";
export const UPDATE_USER_FORM = "UPDATE_USER_FORM";
export const USER_FORM_DELETE = "USER_FORM_DELETE";
export const USER_FORM_DELETE_SUCCESS = "USER_FORM_DELETE_SUCCESS";
export const UPDATE_ACCOUNT_SETTING_FORM = "UPDATE_ACCOUNT_SETTING_FORM";
export const UPDATE_ACCOUNT_SETTING_FORM_SUCCESS =
  "UPDATE_ACCOUNT_SETTING_FORM_SUCCESS";
export const UPDATE_PASSWORD_FORM = "UPDATE_PASSWORD_FORM";
export const UPDATE_USER_EDEC_INTEGRATION = "UPDATE_USER_EDEC_INTEGRATION";
export const UPDATE_USER_EDEC_INTEGRATION_SUCCESS =
  "UPDATE_USER_EDEC_INTEGRATION_SUCCESS";
export const OPEN_LOGIN = "OPEN_LOGIN";
export const CLOSE_LOGIN = "CLOSE_LOGIN";
export const LOGIN_FORM_SEND = "LOGIN_FORM_SEND";
export const LOGIN_FORM_SUCCESS = "LOGIN_FORM_SUCCESS";
export const LOGIN_SAML = "LOGIN_SAML";
export const LOGIN_FORM_FAILED = "LOGIN_FORM_FAILED";
export const CHECK_LOGIN = "CHECK_LOGIN";
export const CHECK_LOGIN_SUCCESS = "CHECK_LOGIN_SUCCESS";
export const CHECK_LOGIN_FAILED = "CHECK_LOGIN_FAILED";
export const DISCONNECT_USER = "DISCONNECT_USER";
export const GET_LOCAL_CONFIGURATOR = "GET_LOCAL_CONFIGURATOR";
export const NOT_FOUND = "NOT_FOUND";
export const CONFLICT = "CONFLICT";
export const AUTH_FORBIDDEN = "AUTH_FORBIDDEN";
export const AUTH_FAILED = "AUTH_FAILED";
export const SERVER_ERROR = "SERVER_ERROR";
export const RESENT_VALIDATION = "RESENT_VALIDATION";
export const BAD_REQUEST = "BAD_REQUEST";
export const LOGIN_REQUIRED = "LOGIN_REQUIRED";
export const RESET_LOGIN_ATTEMPT = "RESET_LOGIN_ATTEMPT";
export const LOGIN_ATTEMPT_NOT_VERIFIED = "LOGIN_ATTEMPT_NOT_VERIFIED";
export const RESENT_VALIDATION_SUCCESS = "RESENT_VALIDATION_SUCCESS";
export const PERMISSION_REFUSED = "PERMISSION_REFUSED";
export const SEND_RECOVER_PASSWORD_FORM = "SEND_RECOVER_PASSWORD_FORM";
export const SAVE_RECOVER_PASSWORD_FORM = "SAVE_RECOVER_PASSWORD_FORM";
export const DISABLE_FAMILY_PRODUCT_FORM_LOADER =
  "DISABLE_FAMILY_PRODUCT_FORM_LOADER";
export const DISABLE_GROUP_FORM_LOADER = "DISABLE_GROUP_FORM_LOADER";
export const SAVE_REGISTER_FORM = "SAVE_REGISTER_FORM";
export const SAVE_REGISTER_FORM_SUCCESS = "SAVE_REGISTER_FORM_SUCCESS";
export const SEND_VERIFICATION = "SEND_VERIFICATION";
export const SAVE_VERIFICATION_SUCCESS = "SAVE_VERIFICATION_SUCCESS";
export const TOKEN_EXPIRED = "TOKEN_EXPIRED";
export const SAVE_VERIFICATION_FAILED = "SAVE_VERIFICATION_FAILED";
export const GET_LOCAL_EDEC_INTEGRATION = "GET_LOCAL_EDEC_INTEGRATION";
export const NOT_ACCEPTABLE = "NOT_ACCEPTABLE";
export const UPDATE_CALCULS_COLUMNS = "UPDATE_CALCULS_COLUMNS";
export const UPDATE_CALCULS_COLUMNS_SUCCESS = "UPDATE_CALCULS_COLUMNS_SUCCESS";
export const ENABLE_USER_LOADER = "ENABLE_USER_LOADER";
export const DISABLE_USER_LOADER = "DISABLE_USER_LOADER";
export const RESET_LOGIN_ERROR = "RESET_LOGIN_ERROR";

export const defaultCalculsColumns = [
  {
    label: "Nom du calcul",
    value: "name",
    order: 1,
    active: true,
  },
  {
    label: "Statut",
    value: "status",
    order: 2,
    active: true,
  },
  {
    label: "Résultat (Changement Climatique - Total)",
    value: "result",
    order: 3,
    active: true,
  },
  {
    label: "Nom du projet",
    value: "projectName",
    order: 4,
    active: true,
  },
  {
    label: "Famille de produit",
    value: "productFamily",
    order: 5,
    active: true,
  },
  {
    label: "Modification (date et heure)",
    value: "updatedAt",
    order: 6,
    active: true,
  },
  {
    label: "Dossiers",
    value: "folders",
    order: 7,
    active: true,
  },
  {
    label: "Version",
    value: "version",
    order: 8,
    active: false,
  },
  {
    label: "Création (date et heure)",
    value: "createdAt",
    order: 9,
    active: false,
  },
];
